/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var E;!function(E){var I,T;(I=E.Geometry||(E.Geometry={}))[I.ADD=1]="ADD",I[I.UPDATE=2]="UPDATE",I[I.REMOVE=4]="REMOVE",(T=E.State||(E.State={}))[T.VISIBILITIES=1]="VISIBILITIES",T[T.VERTEXATTRS=2]="VERTEXATTRS",T[T.TRANSFORMATION=4]="TRANSFORMATION",T[T.HIGHLIGHTS=8]="HIGHLIGHTS",T[T.OCCLUDEES=16]="OCCLUDEES"}(E||(E={}));export{E as ModelDirty};
